import React, { useState } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Person, LocationOn } from "@material-ui/icons";
import {
  Tooltip,
  Typography,
  IconButton,
  Hidden,
  Button,
} from "@material-ui/core";
import styles from "style";
import { EASTWEST_MESSENGER } from "utils/urls";
import usePathListener from "hooks/usePathListener";
import { ABOUT_PATH } from "routes/paths";
import PopoverMenu from "./PopoverMenu";
import {
  LOCATION_POPUP_MENU,
  ONLINE_BANKING_POPUP_MENU,
  ACCOUNT_LOGIN_POPUP_MENU,
} from "./popeverMenus";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   menuItem: {
//     "&:hover": {
//       backgroundColor: "lightgray", // Change this to the desired color
//     },
//   },
// }));

const NavBarRightSection = ({ classes }) => {
  const { pathname } = usePathListener();
  const [locationPopoverOpen, setLocationPopOverOpen] = useState(false);
  const [onlineBankingOpen, setOnlineBankingOpen] = useState(false);
  const [accountOpeningOpen, setAccountOpeningOpen] = useState(false);
  const [locationRef, setLocationRef] = useState(null);
  const [accountOpeningRef, setAccountOpeningRef] = useState(null);
  const [onlineBankingRef, setOnlineBankingRef] = useState(null);
  // const classNames = useStyles();

  const onLocationClick = (event) => {
    setLocationRef(event.currentTarget);
    setLocationPopOverOpen((prev) => !prev);
  };
  const closeLocationPopOver = () => {
    setLocationRef(null);
    setLocationPopOverOpen(false);
  };
  const onOnlineBankingClick = (event) => {
    setOnlineBankingRef(event.currentTarget);
    setOnlineBankingOpen((prev) => !prev);
  };
  const closeOnlineBankingPopOver = () => {
    setOnlineBankingOpen(false);
    setOnlineBankingRef(null);
  };
  const onAccountOpeningClick = (event) => {
    setAccountOpeningRef(event.currentTarget);
    setAccountOpeningOpen((prev) => !prev);
  };
  const closeAccountOpeningPopOver = () => {
    setAccountOpeningOpen(false);
    setAccountOpeningRef(null);
  };
  return (
    <div className={classes.navRight}>
      <Hidden smDown>
        <Link
          className={
            pathname === ABOUT_PATH ? "site-pages active" : "site-pages"
          }
          to={ABOUT_PATH}
          style={{ textDecoration: "none", marginRight: "10px" }}
        >
          <Typography
            color="primary"
            variant="body1"
            style={{ display: "inherit" }}
          >
            <strong>ABOUT US</strong>
          </Typography>
        </Link>
      </Hidden>

      <IconButton
        color="primary"
        rel="noopener noreferrer"
        target="_blank"
        href={EASTWEST_MESSENGER}
        className={classes.button}
        aria-label="Search"
      >
        <i className="fab fa-facebook-messenger" />
      </IconButton>

      <Hidden smDown>
        <Tooltip title="EastWest Stores & ATMs">
          <IconButton
            color="secondary"
            ref={locationRef}
            aria-owns={locationPopoverOpen ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={onLocationClick}
          >
            <LocationOn color="primary" />
          </IconButton>
        </Tooltip>
      </Hidden>
      <PopoverMenu
        anchorRef={locationRef}
        items={LOCATION_POPUP_MENU}
        closePopover={closeLocationPopOver}
        popoverOpen={locationPopoverOpen}
      />
      <Hidden mdUp>
        <Tooltip title="Account Login">
          <IconButton
            color="secondary"
            ref={accountOpeningRef}
            aria-owns={accountOpeningOpen ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={onAccountOpeningClick}
          >
            <Person color="primary" />
          </IconButton>
        </Tooltip>
        <PopoverMenu
          anchorRef={accountOpeningRef}
          items={ACCOUNT_LOGIN_POPUP_MENU}
          closePopover={closeAccountOpeningPopOver}
          popoverOpen={accountOpeningOpen}
        />
      </Hidden>
      <Hidden mdDown>
        <Button
          style={{ marginRight: "5px" }}
          variant="contained"
          color="secondary"
          ref={onlineBankingRef}
          aria-owns={onlineBankingOpen ? "menu-list-grow" : null}
          aria-haspopup="true"
          onClick={onOnlineBankingClick}
          id="btnonlinebanking"
          className="trackme"
        >
          <Person style={{ color: "white" }} /> ONLINE BANKING
        </Button>
        <PopoverMenu
          anchorRef={onlineBankingRef}
          items={ONLINE_BANKING_POPUP_MENU}
          popoverOpen={onlineBankingOpen}
          closePopover={closeOnlineBankingPopOver}
          // className={classNames.menuItem}
        />
      </Hidden>
    </div>
  );
};

export default withStyles(styles)(NavBarRightSection);
